import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MAX_FILE_SIZE_MB } from '../config/upload';

interface UploadHintsProps {
  /** Comma-separated supported formats label, e.g. "JPG, PNG, PDF". */
  formats: string;
  /** When true, shows an Alert reminding users that AI can make mistakes. */
  showAiDisclaimer?: boolean;
}

export function UploadHints({ formats, showAiDisclaimer = false }: UploadHintsProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 1 }}>
      <Typography
        variant="caption"
        component="div"
        sx={{
          color: 'text.secondary',
        }}
      >
        {t('common.uploadHints.supportedFormats', { formats })}
      </Typography>
      <Typography
        variant="caption"
        component="div"
        sx={{
          color: 'text.secondary',
        }}
      >
        {t('common.uploadHints.maxSize', { maxSize: MAX_FILE_SIZE_MB })}
      </Typography>
      {showAiDisclaimer && (
        <Alert severity="info" sx={{ mt: 1 }}>
          {t('common.uploadHints.aiDisclaimer')}
        </Alert>
      )}
    </Box>
  );
}
